import React from 'react';

import { ecpLocatorApi, TInternetShopResponse } from '../../../../rest/ecp-locator';
import { OnlineShops as InternetShopsView } from './online-shops';
import { useRequest } from '../../../../hooks/use-request';

export const OnlineShops = (): JSX.Element => {
  const { data, loading, error } = useRequest<TInternetShopResponse>(
    ecpLocatorApi.getInternetShops,
  );

  return (
    <InternetShopsView
      shops={data?.filter(shop => shop.website) || []}
      isLoading={loading}
      isError={!!error}
    />
  );
};
